import type Paginated from 'app/core/paginable';
import httpApiApplication from 'app/http/httpApiApplication';

import type { CatalogValueTranslation } from '../models/Catalog';
import type { CatalogValueEditable } from '../models/Catalog';
import type { CatalogValue } from '../models/Catalog';
import { type CatalogTypeModel } from '../models/Catalog';
export const baseUrlCatalogTypes = 'catalogs';
export const baseCatalogUrl = 'catalog-values';

export const catalogService = {
  baseCatalogUrl: (): string => {
    return baseCatalogUrl;
  },
  baseCatalogTypeUrl: (): string => {
    return baseUrlCatalogTypes;
  },
  catalogTypesListPaging: (
    page: number,
    pageSize: number,
    params: any = undefined
  ): Promise<Paginated<CatalogTypeModel>> => {
    return httpApiApplication.paginate<CatalogTypeModel>(
      baseUrlCatalogTypes,
      page,
      pageSize,
      params
    );
  },
  listCatalogs: async (): Promise<Array<CatalogTypeModel>> => {
    return httpApiApplication.get(baseUrlCatalogTypes + '/all');
  },
  listCatalogValues: async (type?: string): Promise<Array<CatalogValue>> => {
    return httpApiApplication.get(baseCatalogUrl + '/' + type);
  },
  /**
   * Recupera la lista de valores de un catálogo que tienen como atributo
   * padre, el especificado en el parámetro
   * @param parent Valor del parent
   * @returns Lista de valores que cumplen la condicion registro padre
   */
  listCatalogValuesByParent: async (parent: string): Promise<Array<CatalogValue>> => {
    return httpApiApplication.get(baseCatalogUrl + '/parent/' + parent);
  },
  catalogType: (id?: string, ignoreDefaultLang = false): Promise<CatalogTypeModel> => {
    return httpApiApplication.get(baseUrlCatalogTypes + '/' + id, {
      headers: ignoreDefaultLang ? { lang: true } : undefined
    });
  },
  getCatalog: (id?: string): Promise<CatalogTypeModel> => {
    return httpApiApplication.get(baseUrlCatalogTypes + '/id/' + id);
  },
  langList: (): Promise<Array<string>> => {
    return httpApiApplication.get(baseCatalogUrl + '/langs');
  },
  catalogListPaging: (
    page: number,
    pageSize: number,
    params: any = undefined,
    type: string
  ): Promise<Paginated<CatalogValueEditable>> => {
    // params = { includes: 'Type' };
    return httpApiApplication.paginate<CatalogValueEditable>(
      baseCatalogUrl + '/' + type + '/paginated',
      page,
      pageSize,
      params
    );
  },
  createCatalog: async (values?: CatalogTypeModel) => {
    return httpApiApplication
      .post(baseUrlCatalogTypes, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  },
  updateCatalog: async (values: CatalogTypeModel, id?: string) => {
    return httpApiApplication
      .put(baseUrlCatalogTypes + '/' + id, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  },
  createValue: async (values?: CatalogValueEditable) => {
    return httpApiApplication
      .post(baseCatalogUrl, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  },
  updateValue: async (values: CatalogValueEditable, id?: string) => {
    return httpApiApplication
      .put(baseCatalogUrl + '/' + id, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  },
  deleteValue: (id: string) => {
    return httpApiApplication
      .delete(baseCatalogUrl + '/' + id)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  },
  upsertCatalogTranslation: async (
    id: string,
    language: string,
    value: string
  ): Promise<{ response?: CatalogValueTranslation; error?: any }> => {
    return httpApiApplication
      .put(`${baseCatalogUrl}/${id}/translations/${encodeURIComponent(language)}`, { value })
      .then((response) => ({ response: response as CatalogValueTranslation }))
      .catch((error) => ({ error }));
  },
  urlValueList: (catalog: string): string => {
    return '/catalog-values/' + catalog + '/paginated';
  }
};
